export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/MousePosition/GPmapCenter.png?14f23925a1c78a0b8c00a73b5f0240d7";